import React,{Component} from 'react';
import CreateNewVariable from './CreateVariable';
import { callGET, callPOST, callPUT, callDELETE } from '../../../../Utils/ApiUtil';
import * as ShipConstants from '../../../../Global/Constants';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions';
import { withRouter } from 'react-router';
import PdfTagList from './PdfTagList';
import AceEditor from "react-ace";
import ImageDetails from './ImageDetails';

class HtmlContent extends Component {

	state={
		variableList:[],
		variableListBackup:[],
		isVariableModalOpen:false,
		variablesAndFields:[],
		windowsList:[],
		htmlContentData:{
			drillDownData:[],
			htmlContent:'',
			absoluteWindow:[],
			iterateData:{},
			imageData:{
				id : null,
				data : []
			}
		}
	}
	uploadMultipleFiles = React.createRef();  
	
	componentWillMount() {
    this.fetchVariableList();
    this.variableAndFieldList();
    this.fetchWindowList();
	}

	render() {
		const {variableList,isVariableModalOpen,variablesAndFields,windowsList,htmlContentData} = this.state;
		return (
		  <div className="col-12 " ref={this.props.refAtt}>
	        <div className="card mb-0">
	          <div className="card-header p-2">
	            <div className="card-title"> HTML Content </div>
              </div>
	          <div className="card-body pb-0">
	            <div className="d-flex">
	             	<PdfTagList 
	             		variableList={variableList}
	             		toggleVariableModel={this.toggleVariableModel}
	             		drillDownNextLevel={this.drillDownNextLevel}
	             		goBackDrillDown={this.goBackDrillDown}
	             		htmlContentData={htmlContentData}
	             		insertTextHandler={this.insertTextHandler}
	             		checkIterateColumns={this.checkIterateColumns}
	             		insertGroupTextHandler={this.insertGroupTextHandler}
	             		getFieldDataUsingId={this.getFieldDataUsingId}
	             	/>
	             	<div className="htmlTextarea pr-1 mr-1">
				        <div className="form-group">
				          <label className="">
				            HTML Code 
				          </label>
				          <div className="customTextArea" id="customTextArea">
				              <AceEditor
				                value={htmlContentData.htmlContent}
				                ref="aceEditor"
				                mode="html"
				                theme="github"
				                fontSize={14}
				                width="100%"
				                name="html_code"
				                showPrintMargin={false}
				                editorProps={{ $blockScrolling: true }}
				                onChange={this.htmlContentChangeHandler} 
				                setOptions={{
				                  fontSize:'14px'
				                  }}
				              />
				          </div>
				        </div>
				  	</div>
				  	<ImageDetails 
		                uploadMultipleFiles={this.uploadMultipleFiles} 
		                uploadFilesHandler={this.uploadFilesHandler}
		                onFileChange={this.onFileChange}
		                imageData={this.state.htmlContentData.imageData}
		                deleteUploadFiles={this.deleteUploadFiles}
		                insertTextHandler={this.insertTextHandler}
		              />
	            </div>
	          </div>
	        </div>
	        <CreateNewVariable
	        	isVariableModalOpen={isVariableModalOpen}
	        	variablesAndFields={variablesAndFields}
	        	windowsList={windowsList}
	        	toggleVariableModel={this.toggleVariableModel}
	        	variableList={variableList}
	        	fetchVariableList={this.fetchVariableList}
	        	{...this.props}
	        />
	      </div>
		)
	}

	fetchVariableList = () => {
		const params = this.props.match.params;
	    callGET("variable/paginated-search?functionType=PDF&referenceId="+params.pdfTemplateId)
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variableList:responseData.data.content,variableListBackup:responseData.data.content})
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

	variableAndFieldList = () => {
	    callGET("rates/field-type-list")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({variablesAndFields:responseData.data});
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

  	fetchWindowList = () => {
	    callGET("windows/list?query=&page=0&orderBy=display_name&size=10000&direction=ASC")
	    .then(response => {
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.setState({windowsList:responseData.data.windows.content})
	      }
	    }, (error) => {
	      this.props.failMessage("Something went wrong..");
	    })
  	}

  	toggleVariableModel = () => {
  		this.setState({isVariableModalOpen:!this.state.isVariableModalOpen});
  	}

  	insertTextHandler = (content, type, dependentWindowName='') => {
	    const params = this.props.match.params;
	    let textToInsert = '';
	    if(type === 'img') {
	      textToInsert = content;
	    }else {
	      if(dependentWindowName !== '') {
	        textToInsert = '${'+dependentWindowName+'.'+content+'}';
	      }else {
	        textToInsert = '${'+content+'}';  
	      }
	    }
	    const reactAceComponent = this.refs.aceEditor;
	    
	    const editor = reactAceComponent.editor;
	    var cursorPosition = editor.getCursorPosition();
	    editor.getSession().insert(cursorPosition,textToInsert);
	    // if(dependentWindowName !== '')
	    //   this.props.absoluteWindowHandler(params.windowName+'.'+dependentWindowName);
  	}

	drillDownNextLevel = (parentData) => {
		const prntData = JSON.parse(parentData);
		const updateState = {...this.state};
		updateState['htmlContentData']['drillDownData'].push(prntData);
		updateState['variableList']=prntData.fields;
		this.setState(updateState);
	}

	goBackDrillDown = (itemInd) => {
		console.log('goBackDrillDown')
		const updateState = {...this.state};
	    let drillData = updateState['htmlContentData']['drillDownData'];
	    let existData = this.state['htmlContentData']['drillDownData'];
	    const slicedArray = existData.slice(0, itemInd+1);
	    let variableList = [];
	    if(itemInd !== -1) {
	      drillData = slicedArray;
	      if(slicedArray.length > 0) {
	      	variableList = slicedArray[slicedArray.length-1].fields;
	      }else {
	      	variableList = variableList;
	      }
	    }else {
	      drillData = [];
	      variableList = updateState.variableListBackup;
	    }
	    updateState['htmlContentData']['drillDownData'] = drillData;
		updateState['variableList']=variableList;
		this.setState(updateState);
  	} 

  	htmlContentChangeHandler = (newValue) => {
	    let dependentWindowName = '';
	    const parentFieldArr = this.state.htmlContentData.drillDownData;
	    if(parentFieldArr && parentFieldArr.length > 0) {
	        parentFieldArr.map((pArr,pInd) => {
	          dependentWindowName +=  dependentWindowName === '' ? pArr.api_name : '.'+pArr.api_name;
	        })
	    }
	    const updateState = {...this.state};
	    updateState['htmlContentData']['htmlContent']=newValue;
	    if(dependentWindowName !== '') {
	    	if(this.state.htmlContentData.absoluteWindow.indexOf(dependentWindowName) === -1) {
				const data = this.state.htmlContentData.absoluteWindow;
				data.push(dependentWindowName);
				updateState['htmlContentData']['absoluteWindow'] = data;
			}
	    }
	    this.setState(updateState);
  	}

	insertGroupTextHandler = (dependentWindowName) => {
	    const iterateData = this.state.htmlContentData.iterateData;
	    const reactAceComponent = this.refs.aceEditor;
	    const editor = reactAceComponent.editor;
	    var cursorPosition = editor.getCursorPosition();
	    let textToInsert = '';
	    let dependentWindowNameVal = dependentWindowName
	    if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')]) {
	      if(iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].length > 0) {
	        iterateData['x-'+dependentWindowNameVal.replaceAll('.','-')].map((arr,i) => {
	          const fieldData = this.getFieldDataUsingId(arr);
	          textToInsert += '${'+dependentWindowName+'.'+fieldData.api_name+'} ';  
	        })
	      }
	    }

	    if(textToInsert !== '') {
	      textToInsert = '<x-'+dependentWindowName.replaceAll('.','-')+'>'+textToInsert+'</x-'+dependentWindowName.replaceAll('.','-')+'>';
	    }
	    editor.getSession().insert(cursorPosition,textToInsert);
  	}

	getFieldDataUsingId = fieldId => {
	    let returnVal = '';
	    if(this.state.variableList) {
	      this.state.variableList.map((arr,ind) => {
	        if(arr.id === fieldId) {
	          returnVal = arr;
	        }
	      })
	    }
	    return returnVal;
  	}

  	checkIterateColumns = (e) => {
		const {name,value,checked} = e.target;
		const  parentFieldArr = this.state.htmlContentData.drillDownData;
		const depLayout = parentFieldArr[parentFieldArr.length-1].dependent_layout;
		let dependentWindowName = '';
	 	parentFieldArr.map((pArr,pInd) => {
	        dependentWindowName +=  dependentWindowName === '' ? 'x-'+pArr.api_name : '-'+pArr.api_name;
      	})
		const list = {...this.state.htmlContentData.iterateData}

		if(checked === true) {
			if(list[dependentWindowName]) {
				list[dependentWindowName].push(value);
			}else {
				list[dependentWindowName] = [];
				list[dependentWindowName].push(value);	
			}
		}else {
			// const windIndex = list[dependentWindowName].indexOf(value);
			// list[dependentWindowName].splice(windIndex, 1);
		}
		this.setState({
			htmlContentData:{
				...this.state.htmlContentData,
				iterateData:list
			}
		})
	}

	deleteUploadFiles = (ind) => {
		let updateFiles = this.state['htmlContentData']['imageData']['data'];
		updateFiles = updateFiles.filter((item,index)=>{
			if(index!== ind){
			  return item;
			}
		})
		const updateState = {...this.state};
        updateState['htmlContentData']['imageData']['data'] = updateFiles ? updateFiles : [];
        this.setState(updateState);
	}

  	onFileChange =()=>{
      let inputField = this.uploadMultipleFiles;
      inputField.click();
    }  

  	uploadFilesHandler = (e) => {
      this.uploadFileAPICall(e.target.files);
    }

    uploadFileAPICall= (files)=>{
		let totalFileLength = files.length;
      	Object.entries(files).map(([key, fileItem]) => {
	        const formData = new FormData();            
	        formData.append("upload_file", fileItem);
	        const APIURL = 'files/upload';
	        callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
	        .then(res => {    
	          if(res.status==200){                        
	            const response = res.data;
	            if(response.code === ShipConstants.API_STATUS_SUCCESS) { 
	                const responseData =  response.data;
	                const updateState = {...this.state};
	                const data = { id : responseData, label : responseData , file : fileItem};
	                updateState['htmlContentData']['imageData']['data'].push(data);
	                this.setState(updateState);
	              }else{
	                // this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
	              }                                                
	          }else{
	              // this.props.Loader();
	              // this.props.failMessage('Something went wrong..');
	          }
	        })
	        .catch(err => {
	            console.log(err);
	            // this.props.Loader();
	            // this.props.failMessage('Something went wrong');                    
	        })
	    })
	  }	
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(null, mapDispatchToProps)(withRouter(HtmlContent));